import { PATCH, POST } from './common/common.service'
import { endpointsAuth } from './endpoints'

const AuthService = {
  login: (body) => POST(endpointsAuth.LOGIN, body, false),
  logout: async () => POST(endpointsAuth.LOGOUT, null, false),
  newPassword: async (body) => PATCH(endpointsAuth.NEWPASSWORD, body),
  recoverPassword: async (body) => POST(endpointsAuth.RECOVERPASSWORD, body),
}

export default AuthService
